import { withStyles } from "@material-ui/core"
import Typography from "@mui/material/Typography"
import React, { useEffect, useState } from "react"
import { grayColor } from "../../../style/style"
import WidgetCommon from "../Common/widgetCommon"

const styles = () => ({})

const TotalClasses = (props) => {
  const {
    isLoading,
    insights,
    allowEdits,
    handleWidgetChange,
    widgetId,
    gridStep,
    position,
    size,
    handleRemove,
  } = props
  const [totalClasses, setTotalClasses] = useState(null)

  useEffect(() => {
    if (insights) {
      setTotalClasses(
        insights
          .map((insight) => insight.class_name)
          .filter((value, index, self) => self.indexOf(value) === index).length,
      )
    }
  }, [insights])

  return (
    <WidgetCommon
      widgetId={widgetId}
      title="Total Classes"
      isLoading={isLoading}
      hasNoData={!totalClasses}
      size={size}
      position={position}
      allowResize={true}
      allowEdits={allowEdits}
      handleWidgetChange={handleWidgetChange}
      gridStep={gridStep}
      handleRemove={handleRemove}
    >
      <br></br>
      <Typography variant="h2" style={{ color: grayColor[2] }}>
        {totalClasses}
      </Typography>
    </WidgetCommon>
  )
}

export default withStyles(styles)(TotalClasses)
